<template>
  <div class="paymentSuccessContainer">
    <div class="grid mt-6">
      <p class="nunitoBold cancelText">
        {{ $t('k_cancel_plan') }}
      </p>
      <h2 class="hrLine"></h2>
      <p
        class="ralewayRegular cancelTextDescription"
        v-html="
          $t('k_confirm_cancel_plan', {
            k_confirm_cancel_bold: $t('k_confirm_cancel_bold')
          })
        "
      ></p>
    </div>
    <form action="#" @submit.prevent="submit">
      <div class="buttonGrid mt-10">
        <div class="stButton cancelPlanButton">
          <div class="stButtonCaption nunitoBold" v-on:click="cancelPlan">
            {{ $t('k_confirm_title') }}
          </div>
        </div>
        <div class="stButton cancelButton">
          <div class="stButtonCaption nunitoBold" v-on:click="cancelSubmit">
            {{ $t('k_cancel_title') }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../plugins/api'
import { trackEvent } from '../plugins/analyticsTracker'
export default {
  methods: {
    cancelPlan: async function() {
      trackEvent(this.$constants.WEB_MANAGE_SUBS_UNSUBSCRIBE)
      try {
        const urlGet = process.env.VUE_APP_BACKEND_URL
        await api.delete(
          `${urlGet}/user/stripe/subscription/${this.$route.query.subscriptionId}`
        )
        trackEvent(this.$constants.WEB_MANAGE_SUBS_UNSUBSCRIBE_CONFIRM)
        this.$router.push('profile')
      } catch (error) {
        console.log(error)
        await this.$store.dispatch('setError', {
          errorKey: 'k_generic_error_title',
          errorSubKey: 'k_generic_error_subtitle',
          errorImage: '@/assets/images/mosquita_generic_error.png',
          redirect: '/profile'
        })
        this.$router.push({
          path: '/error'
        })
      }
    },
    cancelSubmit: function() {
      trackEvent(this.$constants.WEB_MANAGE_SUBS_UNDO)
      this.$router.push('profile')
    }
  }
}
</script>
<style lang="scss">
.paymentSuccessContainer {
  .buttonGrid {
    grid-template-columns: repeat(16, 1fr);
    display: grid;
  }

  .cancelPlanButton {
    padding: 10px 0;
    grid-row: 1;
    grid-column: 3/8;
    font-size: 0.875em;
  }

  .cancelButton {
    padding: 10px 0;
    grid-row: 1;
    grid-column: 10/15;
    font-size: 0.875em;
  }

  .cancelTextDescription {
    grid-row: 3;
    grid-column: 2/12;
    font-size: 0.75em;
    color: var(--formColor);
    text-align: left;
  }
  .cancelText {
    grid-row: 1;
    grid-column: 2/12;
    font-size: 1.5em;
    color: var(--tertiary);
    text-align: left;
  }

  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .fbLogo {
    align-self: center;
    width: 10%;
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .hrLine {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid var(--line1);
    line-height: 0.1em;
    margin: 10px 0 20px;
    grid-row: 2;
    grid-column: 2/12;
  }

  .hrLine span {
    padding: 0 10px;
    background: #fff;
    color: var(--line1);
    font-size: 0.5em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
